export default function PasswordHint() {
  return (
    <p className="text-sm">
      Password must be at least 8 characters in length, at least one uppercase
      letter, and at least one number.
    </p>
  );
}
